<template>
    <div style="width: 100%; padding-top: 50px; padding-bottom: 50px;">
        <div class="login-container">
            <div class="container inner-login-container">
                <div class="row">
                    <div class="col-12">
                        <input class="form-control" type="email" placeholder="EMAIL" v-model="email"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <input class="form-control" type="password" placeholder="PASSWORD" v-model="password"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        Do not have account? Click <a href="/signUp">SIGN UP</a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button class="btn btn-primary form-control" @click="submit">SIGN IN</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {signUpCustomer, userSignIn} from "@/api/users";
import {showDialog} from "@/api/common";
import EventBus from "@/api/event-bus";

export default {
    name: "SignIn",
    data() {
        return {
            email:'',
            password:'',
            errorMessage:null,
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        validateEmail: function() {
            if(this.$data.email === null || this.$data.email.length === 0) {
                return false;
            }

            let validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if(this.$data.email.match(validRegex)) {
                return true;
            }
            return false;
        },
        submit: function() {
            if(this.validateEmail() === false) {
                showDialog("Incorrect Email");
                return false;
            }

            let self = this;
            userSignIn(this.$data.email, this.$data.password)
                .then(function(data) {
                    if(data.success === true) {
                        localStorage.setItem("JSTOKEN", data.item.token);
                        localStorage.setItem("email", data.item.email);
                        localStorage.setItem("id", data.item.id);
                        EventBus.$emit("logon", true);
                        // showDialog(data.message);
                        self.$router.push('/');
                    } else {
                        showDialog(data.message);
                    }
                })
                .catch(function(err) {
                    console.log(err);
                    if(err.response !== undefined) {
                        console.log(err.response);
                    }
                    showDialog("Something went wrong", "OOPS!");
                })
        }
    }
}
</script>

<style scoped>
.login-container {
    width: 500px;
    max-width: 90%;
    margin: auto;
    padding: 50px 20px 50px 20px;
    border: 1px solid gray;
    border-radius: 10px;
    background-color: white;
}
.inner-login-container .row {
    padding-top: 20px;
    text-align: center;
}
.inner-login-container input {
    text-align: center;
}
</style>
